__turbopack_context__.v({
  "bottomSubMenu": "jqTHuG_bottomSubMenu",
  "bottomSubMenuContent": "jqTHuG_bottomSubMenuContent",
  "bottomSubMenuOverlay": "jqTHuG_bottomSubMenuOverlay",
});
